import CarouselSlider from './CarouselSlider';

export default CarouselSlider;
